import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import NewTransaction from "../../../home/newtransaction";
import { PREVIOUS } from "./constants";
import styles from "./empty.module.scss";
// import { ACTIVE_STATUS } from "../../constants";
export function EmptyContractsList(props: any) {
  const { feedBack, pageType } = props;
  const [showModal, setShowModal] = useState<boolean>(false);
  const handleModal = useCallback(() => {
    setShowModal(!showModal);
  }, [showModal]);
  const onClose = () => {
    setShowModal(false);
  };
  const { t } = useTranslation();
  return (
    <div className={styles.emptyListContainer}>
      <img src="../../../assets/images/svg/emptyContracts.svg" />
      <p>
        {pageType === PREVIOUS
          ? t("lbl_no_contracts_previous")
          : t("lbl_no_contracts")}
      </p>
      <a onClick={handleModal}>{t("lbl_start_new_contract")}</a>
      <NewTransaction
        showModal={showModal}
        onClose={onClose}
        fetchAllContract={feedBack}
      />
    </div>
  );
}
